<template>
  <input-widget
    type="select2"
    :attribute="attribute"
    :items="items"
    :search-handler="handler"
    display-field="Lot: ${item.lot_no}"
    :model="model"
    :disabled="disabled"
    @select2Select="onSelect"
    @select2Unselect="onUnselect"
  />
</template>


<script>
  import InputWidget from "../components/input-widget/InputWidget";
  import LotService from "../../modules/lots/LotsService";

  export default {
    name: "LotSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      expand: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      auctionUuid: {
        type: String,
        default: null
      },
      status: {
        type: String,
        default: null
      },
    },
    methods: {
      async handler(lot_no) {
        const params = {
          lot_no: lot_no,
          expand: this.expand,
        };

        if (this.auctionUuid) {
          params.auction_uuid = this.auctionUuid;
        }
        if (this.status) {
          params.status = this.status
        }
        return LotService.getLots(params);
      },
      updateItems() {
        if (this.items.length) {
          return;
        }
        const uuid = this.attribute.substr(this.attribute.length - 5, 5);
        if (uuid === '_uuid') {
          let toListenAttribute = this.attribute.substr(0, this.attribute.length - 5);
          if (this.model[toListenAttribute]) {
            this.items.push(this.model[toListenAttribute]);
          }

          this.$watch(`model.${this.attribute}`, function () {
            if (this.model[toListenAttribute] && this.model[toListenAttribute].uuid === this.model[this.attribute]) {
              this.items.push(this.model[toListenAttribute]);
            }
          }, {deep: true});
        }
      },
      onSelect(data) {
        this.$emit('select', data);
      },
      onUnselect(data) {
        this.$emit('unselect', data);
      }
    },
    mounted() {
      this.updateItems();
    }
  }
</script>

<style scoped>

</style>